var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from '@aws-amplify/auth';
import { createUser as createUserMutation, updateUser as updateUserMutation } from '../../../graphql/mutations';
import { deleteUser as deleteUserMutation } from './graphql/mutations';
import { callGraphQL } from '../../common/common';
import { updateUserPII } from './UserPIIMutations';
import { mapCreateUser, mapUpdateUser } from './models/user';
import Axios from 'axios';
import { getSignedUrl, UploadType } from '../../S3Service';
/**
 * Returns the created user
 * Requires Cognito Groups: [Service]
 * @param userId Id of the user
 * @param username Username of the user
 * @param name Name of the user
 */
export function createUser(userId, username, name) {
    return __awaiter(this, void 0, void 0, function* () {
        const userParams = {
            id: userId,
            username,
            name
        };
        const resp = yield callGraphQL(createUserMutation, { input: userParams });
        return mapCreateUser(resp);
    });
}
/**
 * Returns true if the user is deleted and false if it does not.
 * Requires Cognito Groups: [Service]
 * @param userId The id of the user to be deleted
 */
export function deleteUser(userId) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(deleteUserMutation, { input: { id: userId } }).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.deleteUser; });
    });
}
/**
 * Returns the updated user
 * @param userID Id of the user to update
 * @param email Updated email
 * @param name Updated name
 * @param birthDate
 * @param phoneNumber updated phone number
 */
export function updateUser(userID, email, name, birthDate, phoneNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            id: userID,
            name
        };
        const attributes = {
            email,
            name,
            phone_number: phoneNumber
        };
        const user = yield Auth.currentAuthenticatedUser();
        yield Auth.updateUserAttributes(user, attributes);
        yield updateUserPII(userID, { email, phoneNumber: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : null, birthDate: birthDate !== null && birthDate !== void 0 ? birthDate : null });
        const resp = yield callGraphQL(updateUserMutation, { input: params });
        return mapUpdateUser(resp);
    });
}
export function updateUserProfilePictureDB(id, profilePictureKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            id,
            profilePicture: profilePictureKey
        };
        return callGraphQL(updateUserMutation, { input: params }).then((res) => mapUpdateUser(res));
    });
}
export const getExtension = (file) => {
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(file);
    return extension ? extension[1] : undefined;
};
/**
 * Given a userId and an input file
 * Uploads the image to s3 and updates the users profile picture key
 * Returns the user with the updated profile picture key
 * @param userId
 * @param inputFile
 */
export function updateUserProfilePicture(userId, inputFile) {
    return __awaiter(this, void 0, void 0, function* () {
        const extension = getExtension(inputFile.name);
        if (!extension)
            throw new Error('Could not find files extension');
        if (!['jpg', 'jpeg', 'png'].includes(extension.toLowerCase())) {
            throw new Error('Invalid Extension: Expected extension of type jpg, jpeg, or png');
        }
        const signed = yield getSignedUrl(inputFile.name, inputFile.type, UploadType.PROFILE_PICTURE);
        yield Axios.put(signed.payload.signedUrl, inputFile, {
            headers: {
                'Content-Type': inputFile.type
            }
        });
        return signed.payload.key.replace('public/', '');
    });
}
